import {
  BaseInputSchemaValidator,
  getFieldElementValidator,
  InputElementTypeLiterals,
  isTextCellAdapterRule,
  ITextInputElement,
  isMaxLengthValidation,
  ValidationErrorVariables,
} from "@graffer-inc/form-schema";

const SupportedInputElementTypes = ["text"] as InputElementTypeLiterals[];

export class TenantProcessResultInputElementValidator extends BaseInputSchemaValidator<ITextInputElement> {
  constructor(readonly element: ITextInputElement) {
    super(element);
  }

  validate() {
    const results = getFieldElementValidator(this.element).validate();
    this.append(results, this.supportInputElementType());
    this.append(results, this.notRequired());
    this.append(results, this.notHidden());
    this.append(results, this.notLabelEmpty());
    this.append(results, this.maxLength());
    this.append(results, this.cellSize());
    return results;
  }

  assertion() {
    this.assertError(this.validate());
  }

  label() {
    return this.notLabelEmpty() ?? this.commonValidator.label();
  }

  description() {
    return this.commonValidator.description();
  }

  validations() {
    return this.maxLength() ?? this.cellSize();
  }

  private notLabelEmpty() {
    return this.element.label.text.length === 0
      ? "項目名を入力してください"
      : undefined;
  }

  private supportInputElementType() {
    return !SupportedInputElementTypes.includes(this.element.inputType)
      ? "サポートしていない入力項目が含まれています"
      : undefined;
  }

  private notRequired() {
    return this.element.required ? "必須項目は設定できません" : undefined;
  }

  private notHidden() {
    return this.element.hidden ? "非表示項目は設定できません" : undefined;
  }

  private maxLength() {
    const validation = this.maxLengthVaidation;
    if (!validation) {
      return undefined;
    }
    if (
      typeof validation.value !== "number" ||
      !Number.isInteger(validation.value)
    ) {
      return "不正な値が入っています";
    }
    return validation.value >
      ValidationErrorVariables.text_input.defaultMaxLength ||
      validation.value < 1
      ? `設定可能な最大値制限は1から${ValidationErrorVariables.text_input.defaultMaxLength}文字の間です`
      : undefined;
  }

  private cellSize() {
    const pdfAdapterRule = this.schema.pdfAdapterRule;
    if (pdfAdapterRule && isTextCellAdapterRule(pdfAdapterRule)) {
      const validation = this.maxLengthVaidation;
      if (!validation || typeof validation.value !== "number") {
        return "PDFマッピングにおいてテキストセル設定がされているので、最大文字数バリデーションは必須です";
      }
      const cellSizeMax =
        pdfAdapterRule.cellSize.horizontal * pdfAdapterRule.cellSize.vertical;
      if (validation.value > cellSizeMax) {
        return `PDFマッピングにおけるテキストセル設定のセルサイズが${cellSizeMax}文字なので、最大文字数バリデーションは${cellSizeMax}文字以下に設定してください`;
      }
    }
    return undefined;
  }

  private get maxLengthVaidation() {
    return this.schema.validations.find(isMaxLengthValidation);
  }
}
